/**
 * Main JavaScript file
 */

(function () {
	'use strict';

	// Initialize when DOM is ready
	document.addEventListener('DOMContentLoaded', function () {
		console.log('Batatinha theme loaded');
		// Add your JavaScript here
	});
})();

